export enum SanitizeTypes {
    HTML,
    STYLE,
    SCRIPT,
    URL,
    RESOURCE_URL
}
